export enum PeriodType {
  Second = 1,
  Minute = 2,
  Hour = 3,
  Daily = 4
}
